module.exports = __webpack_public_path__ + "static/media/ehire.91d20407.png";